import React, { useState, useEffect } from 'react';
import leaf from '../assets/leaf.png';
import carouselIcon from '../assets/carousel_icon.png';
import value1 from '../assets/values1.jpg';
import value2 from '../assets/values2.webp';
import value3 from '../assets/values3.jpg';
import value4 from '../assets/values4.webp';
import value5 from '../assets/values5.jpg';
import value6 from '../assets/values6.webp';

const Values = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    const slides = [
        {
            image: value1,
            title: "Comfort & Wellbeing (Hygge)",
            description: "Creating warm, cosy spaces where children feel safe and inspired."
        },
        {
            image: value2,
            title: "Curiosity",
            description: "Encouraging children’s natural wonder and love of discovery."
        },
        {
            image: value3,
            title: "Independence",
            description: "Empowering children to make choices and grow in confidence."
        },
        {
            image: value4,
            title: "Creativity",
            description: "Inspiring imagination through open-ended play and natural environments."
        },
        {
            image: value5,
            title: "Connection",
            description: "Building strong, trusting relationships with families and the community."
        },
        {
            image: value6,
            title: "Sustainability",
            description: "Teaching care for the planet through mindful, eco-conscious practices."
        }
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setActiveIndex((current) => (current + 1) % slides.length);
        }, 5000);
        return () => clearInterval(interval);
    }, [slides.length]);

    return (
        <div className="values-section">
            <div className="values-decoration">
                <div className="decoration-circle"></div>
                <img src={leaf} alt="" className="decoration-leaf" />
            </div>

            <div className="values-container">
                <div className="carousel-wrapper">
                    {slides.map((slide, index) => (
                        <div
                            key={index}
                            className={`carousel-slide ${index === activeIndex ? 'active' : ''}`}
                            style={{ backgroundImage: `url(${slide.image})` }}
                        >
                            <div className="slide-overlay"></div>
                            <div className="slide-content">
                                <img src={carouselIcon} alt="icon" className="slide-icon" />
                                <h2>{slide.title}</h2>
                                <p>{slide.description}</p>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="carousel-pagination">
                    {slides.map((_, index) => (
                        <button
                            key={index}
                            className={`pagination-dot ${index === activeIndex ? 'active' : ''}`}
                            onClick={() => setActiveIndex(index)}
                            aria-label={`Go to slide ${index + 1}`}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Values;
